import { isEmpty } from 'lodash/fp'
import z from 'zod'

const FormSchema = z.object({
    No1: z.array(z.enum(["同意する"]), { message: "必須です" }).refine((data) => !isEmpty(data), "必須です")
})

const CrossCheckSchema = z.object({
    No1: z.array(z.enum(["同意する"])).optional()
}).superRefine((data, ctx) => {
})

export const FormInputSchema = z.intersection(FormSchema, CrossCheckSchema)
